export default "__VITE_ASSET__DuTBXzP$__"